<div *ngIf="visible" class="form-container">
    <h2>Crear Contraseña</h2>
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
      <!-- Campo Nombre -->
      <div class="form-group">
        <label for="Nombre">Nombre</label>
        <input
          id="Nombre"
          type="text"
          formControlName="Nombre"
          placeholder="Ingrese su nombre"
        />
      </div>
  
      <!-- Campo Correo Electrónico (Bloqueado) -->
      <div class="form-group">
        <label for="Email">Correo Electrónico</label>
        <input
          id="Email"
          type="email"
          formControlName="Email"
          placeholder="Ingrese su correo electrónico"
        />
      </div>
  
      <!-- Campo Contraseña -->
      <div class="form-group">
        <label for="Clave">Contraseña</label>
        <div class="password-container" style="display: flex; align-items: center; width: 100%;">
          <input
            id="Clave"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="Clave"
            placeholder="Ingrese su contraseña"
            style="flex: 1;"
          />
          <button type="button" class="toggle-password" (click)="togglePassword()" style="margin-left: 10px;">
            <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
          </button>
        </div>
        <small *ngIf="controls['Clave'].invalid && controls['Clave'].touched" class="error">
          La contraseña es obligatoria y debe tener al menos 6 caracteres.
        </small>
      </div>
  
      <!-- Campo Confirmar Contraseña -->
      <div class="form-group">
        <label for="confirmClave">Confirmar Contraseña</label>
        <div class="password-container" style="display: flex; align-items: center; width: 100%;">
          <input
            id="confirmClave"
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmClave"
            placeholder="Confirme su contraseña"
            style="flex: 1;"
          />
          <button type="button" class="toggle-password" (click)="toggleConfirmPassword()" style="margin-left: 10px;">
            <i class="pi" [ngClass]="showConfirmPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
          </button>
        </div>
        <small *ngIf="controls['confirmClave'].invalid && controls['confirmClave'].touched" class="error">
          Las contraseñas deben coincidir.
        </small>
      </div>
  
      <!-- Botón Crear Contraseña -->
      <div class="form-group">
        <button type="submit" [disabled]="passwordForm.invalid">Crear Contraseña</button>
      </div>
    </form>
</div>
  